<template>
  <div class="RequestHistoryCommentsComponent">
    <p v-if="requestId == ''">{{ lang.infotext_1 }}</p>
    <div v-if="requestId != ''">

      <!-- <p v-if="comments.length == 0">{{ lang.infotext_3 }}</p> -->

      <div class="list-details" v-if="comments.length > 0">
        <p class="info-text">{{ lang.infotext_2 }}:</p>
        <b-list-group>


          <div v-for="(comment, index) in comments" :key="index">
            <b-list-group-item>
              <p >{{ longDateToShort(comment.creationDate) }} |  {{ comment.login }} | 
                <span 
                v-if="comment.type == 'Comment on: Done' ||
                      comment.type == 'Done' ||
                      comment.type == 'Request created' ||
                      comment.type == 'Release to production' ||
                      comment.type == 'Submit'
                " 
                class="positive-comment">{{comment.type}}</span>
                <span v-else-if="comment.type == 'Comment on: Return to requester' ||
                      comment.type == 'Return to requester' ||
                      comment.type == 'Return for rework'
                
                " 
                class="negative-comment">{{comment.type}}</span>
                
                <span v-else class="normal-comment">{{comment.type}}</span>
                              
              </p>
              <span v-if="comment.comment != ''">
                <p class="task-reason-text">{{ comment.comment }}</p>
                
              </span>
                
            </b-list-group-item>

          </div>


        </b-list-group>
      </div>


    </div>


  </div>
</template>

<script>

import * as Tools from '@/Tools/Tools';


export default {
  name: "RequestHistoryCommentsComponent",
  props: {
    lang: Object,
    parent: String
  },
  components: {

      
  },
  data() {
    return {
        
      comments: [],
        
    }
  },
  computed: {
    name() {
      return   "RequestHistoryCommentsComponent" + this.parent
    },
    requestId() {
      let requestId = "--";

      if (this.$route.path == "/RequestManager/RequestDetails") {
          
        
        requestId = this.$route.query.requestId;
      }
      if (this.$route.path == "/RequestManager/RequestTable") {

        if (this.$store.getters.selectedRequestRows.length != 0) {
            
          requestId = this.$store.getters.selectedRequestRows[0].col___requestId.requestId;
                        
        }
      }
      
      

      return requestId;

    },
        
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
      
  },
  created() {


    this.getComments();


  },
  watch: {
    requestId: function () {


      this.getComments();


    },
      
    reloadedAfterActionComplex: {
      handler: function (newValue) {
          
        for (let el in newValue) {
            
          if (newValue[el].name == this.name) {

            if (newValue[el].status == true) {

              this.getComments(this);

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
  },
  
  methods: {
    prepareAssing(str) {
        
        
        let temp = str.split(";");
        return temp[0] + " | " + temp[1] + " | " + temp[2]

    },
    longDateToShort(date) {
        return Tools.longDateToShort(date);
    },
    getComments() {



      let vue = this;

      const obj = {
        requestId: this.requestId
      }
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getHistoryComments", obj)
        .then((result) => {

            console.log(result)
            if (result.status == "OK") {

              vue.comments = result.data
              // for (let i = 0, lei = vue.comments.length; i < lei; i++) {

              //   let pos = vue.comments[i].type.indexOf(":");
              //   if (pos != -1) {
              //     vue.comments[i].comment = vue.comments[i].Message;
              //     vue.comments[i].creationDate = vue.comments[i].ReportedTime;  
              //     vue.comments[i].login = "Unknown user"; 
              //     vue.comments[i].status = "Unknown type"; 
              //   }
                  
              // }

                
            }


        })
    },
      
      

  }


}
</script>
<style lang="scss">
 @import "./../../scss/_custom.scss";
  .RequestHistoryCommentsComponent {
    .task-buttons {
        margin-left: 50px;

    }

    .task-reason-text {
        margin-left: 20px;
    }

    .list-group-item {
        margin-top: 5px;
    }
    .normal-comment{
        color: $yellow;
    }
    .positive-comment{
        color: $green;
    }
    .negative-comment{
        color: $orange;
    }
    
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/RequestHistoryCommentsComponent.vue